import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Persist whichever token the backend gave us (Google OAuth returns
        // session_token; JWT flows return access_token). Either works as a
        // Bearer token on subsequent API calls.
        const tok = data?.access_token || data?.session_token;
        if (tok) setStoredToken(tok);
        if (data?.user) setUser(data.user);
        window.history.replaceState(null, "", "/feed");
        const nextPath = data.user?.onboarded ? "/feed" : "/onboarding";
        navigate(nextPath, { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 rounded-full border-2 border-primary/60 border-t-transparent animate-spin" />
        <p className="text-sm text-muted-foreground font-mono uppercase tracking-[0.25em]">Tuning in…</p>
      </div>
    </div>
  );
}
